import { Table } from "@/features/Table";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type C5StaticDatum, porfolios_columns } from "./columns";
import {
  type FilterC5StaticDatumsSchema,
  FilterC5StaticDatums,
} from "./filter";

const client = Clients.C5;
const table_name = Tables.C5_STATIC_DATA;

export const C5StaticDatumsTable = () => {
  return (
    <Table<C5StaticDatum, FilterC5StaticDatumsSchema>
      label="Actifs"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      filter={<FilterC5StaticDatums />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
